const locale = {
  'en-US': {
    DEAR: 'Dear,please login!',
    PRODUCT_OVERVIEW: 'PRODUCT OVERVIEW',
    OVERVIEW:
      'TM PlAS CLOUD is based on a self-developed communication standard by Techmation, equipping with Techmation edge servers, and integrates injection molding machine control system, manipulators and related auxiliary machineries. It provides with one-stop service for device management, craft management, runtime monitoring, manufacturing process tracing etc. The system undertakes the collection of workshop equipment data, intercommunicates with ERP and MES, thus getting through the information island, closing the loop for production, and is deployed locally, plug and play.',
    PRODUCT_PROPERTY: 'PRODUCT PROPERTY',
    STANDARD: 'Visualizable',
    REAL_TIME: 'Interconnecting',
    TRANSPARENCY: 'Traceable',
    HEALTH: 'Expandable',
    RELATED_DEVICE: 'RELATED DEVICE',
    IM: 'Injection Molding Machine',
    CHILLER: 'Chiller',
    TCU: 'Mold Temperature Machine',
    DRIER: 'Dryer',
    PICKER: 'Picker',
    WECHAT_APPLET: 'Wechat applet',
    COMPONY: 'NINGBO TECHMATION SOFTWARE CO.,LTD.',
    ADDRESS: 'No. 88, Dagang 5th Road, Beilun District, Ningbo City, Zhejiang Province',
  },
  'zh-CN': {
    DEAR: '亲爱的用户，请登录',
    PRODUCT_OVERVIEW: '产品概述',
    OVERVIEW:
      '弘塑云，基于弘讯自研通讯标准，搭载弘讯边缘服务器，整合塑机控制系统、机械手及相关辅机设备，提供一站式服务，实现设备管理、工艺管理、即时监控、生产过程追溯等功能。系统对下承接车间设备数据采集，对上与ERP，MES互通，打通信息孤岛，实现生产闭环，本地化部署，即插即用。',
    PRODUCT_PROPERTY: '产品特性 PROPERTY',
    STANDARD: '可视化',
    REAL_TIME: '可互通',
    TRANSPARENCY: '可追溯',
    HEALTH: '可扩展',
    RELATED_DEVICE: '相关设备 DEVICE',
    IM: '注塑机',
    CHILLER: '冷水机',
    TCU: '模温机',
    DRIER: '干燥机',
    PICKER: '机械手',
    WECHAT_APPLET: '微信小程序',
    COMPONY: '宁波弘讯软件开发有限公司',
    ADDRESS: '浙江省宁波市北仑区大港五路88号',
  },
  'zh-TW': {
    DEAR: '親愛的用戶，請登錄！',
    PRODUCT_OVERVIEW: '產品概述',
    OVERVIEW:
      '弘塑雲，基於弘訊自研通訊標準，搭載弘訊邊緣服務器，綜合塑機控制系統、機械手及相關輔機設備，提供一站式服務，實現設備管理、工藝管理、即時監控、生產過程追溯等功能。 系統對下承接車間設備資料獲取，對上與ERP，MES互通，打通信息孤島，實現生產閉環，當地語系化部署，隨插即用。',
    PRODUCT_PROPERTY: '產品特性 PROPERTY',
    STANDARD: '視覺化',
    REAL_TIME: '可互通',
    TRANSPARENCY: '可追溯',
    HEALTH: '可擴展',
    RELATED_DEVICE: '相關設備 DEVICE',
    IM: '注塑機',
    CHILLER: '冷水機',
    TCU: '模溫機',
    DRIER: '乾燥機',
    PICKER: '機械手',
    WECHAT_APPLET: '微信小程式',
    COMPONY: '寧波弘訊軟體發展有限公司',
    ADDRESS: '浙江省寧波市北侖區大港五路88號',
  },
};
export { locale };
